import "core-js/modules/web.dom-collections.for-each.js";
import util from '@/libs/util';
import { SysEnvConfigList, GetEnvNames } from '@/api/sys.user';
export default {
  namespaced: true,
  state: {
    VUE_APP_API: null,
    VUE_APP_PRINT_TPL: null,
    VUE_APP_DOWN: null,
    VUE_APP_IWMS_API: null,
    VUE_APP_FILE_PATH: null
  },
  mutations: {
    SET_VUE_APP_API: function SET_VUE_APP_API(state, value) {
      state.VUE_APP_API = value;
    },
    SET_VUE_APP_PRINT_TPL: function SET_VUE_APP_PRINT_TPL(state, value) {
      state.VUE_APP_PRINT_TPL = value;
    },
    SET_VUE_APP_DOWN: function SET_VUE_APP_DOWN(state, value) {
      state.VUE_APP_DOWN = value;
    },
    SET_VUE_APP_IWMS_API: function SET_VUE_APP_IWMS_API(state, value) {
      state.VUE_APP_IWMS_API = value;
    },
    SET_VUE_APP_FILE_PATH: function SET_VUE_APP_FILE_PATH(state, value) {
      state.VUE_APP_FILE_PATH = value;
    }
  },
  actions: {
    asyncApiPath: function asyncApiPath(_ref, api) {
      var commit = _ref.commit,
          state = _ref.state;

      // console.log('asyncApiPath------------')
      // console.log('userApi------------', util.cookies.get('userApi'))
      if (!api) {
        return;
      }

      util.func.formatUrl(api).forEach(function (item) {
        commit("SET_".concat(item.VarName), item.UrlPrefix);
      });
    }
  }
};